import React from 'react';
import {
  Menu,
  MenuItem,
  Typography,
  ListItemText,
  CircularProgress,
} from '@mui/material';

interface PopupGroupMembersProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  members?: string[];
  width?: number | string;
}

const PopupGroupMembers: React.FC<PopupGroupMembersProps> = ({
  anchorEl,
  open,
  onClose,
  loading = false,
  members = [],
  width = 260,
}) => {
  let content;

  if (loading) {
    content = (
      <MenuItem disableRipple>
        <CircularProgress size={20} />
      </MenuItem>
    );
  } else if (members.length > 0) {
    content = members.map((member: string) => (
      <MenuItem key={member} disableRipple>
        <ListItemText primary={member} />
      </MenuItem>
    ));
  } else {
    content = (
      <MenuItem disableRipple>
        <Typography>No members found</Typography>
      </MenuItem>
    );
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      MenuListProps={{
        sx: { width },
      }}
    >
      <Typography sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
        Members
      </Typography>

      {content}
    </Menu>
  );
};

export default PopupGroupMembers;